import React from "react"
import { Link } from "gatsby"

import Skills from "../components/skills"

const AboutText = props => (
  <>
    <p>
      Hi!

      <br /> I'm Steve, a Manchester, UK based software engineer with{" "}
      {calculateYears(new Date(2013, 8, 8))} years of commercial experience in
      front-end, back-end and cloud based software development. My speciality is
      .NET & Azure and I hold multiple development Certifications
      and Awards (mostly Microsoft)
    </p>
    See <a href="https://www.linkedin.com/in/ste-baker-dev/">my LinkedIn</a> for more info
    <p></p>

    {props.detailed && (
      <>
        <p>
          I originally started tinkering with computers at the age of 10 and
          very quickly found a passion in building web applications / game
          development (& playing games of course!) which I then pursued as a
          career - "Do what you love and never work a day in your life". Being a
          Software Engineer can be hard work at times but is a challenging
          and rewarding path
        </p>

        <h2>Tech Stack</h2>
        <p>I've worked with a range of tech over the years. Out of the many languages, frameworks and stacks, these are the ones i'm most comformatble and familar with:</p>
        <Skills></Skills>

        <h2>Projects & Clients</h2>
        <p>
          I've worked on a range of different projects and clients over the years in a range
          of industries; Some companies I've worked directly for are:
        </p>
        <ul className="list-compact">
          <li>Liberty Gas Group</li>
          <li>DRSP Limited</li>
          <li>CarFinance247</li>
          <li>AND Digital (Consulting)</li>
          <li>TLA (TheLeadAgency)</li>
        </ul>

        <p>
          As a Software Consultant, I've worked a range of companies such as:
        </p>
        <ul className="list-compact">
          <li>evestor/OpenMoney</li>
          <li>TalkTalk</li>
          <li>PwC (PricewaterhouseCoopers)</li>
          <li>Lookers</li>
          <li>Co-op Group</li>
          <li>The Princes Trust</li>
          <li>Sky</li>
          <li>Department for Education (GOV.UK)</li>
        </ul>

        <p>
          See my <Link to="/portfolio">Portfolio</Link> for a few of my public side
          projects i've started (and probably not finished)
        </p>
      </>
    )}
  </>
)

function calculateYears(birthday) {
  // birthday is a date
  var ageDifMs = Date.now() - birthday
  var ageDate = new Date(ageDifMs) // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970) + 1
}

export default AboutText
